module.exports = __webpack_public_path__ + "img/Speaker=Amanda DoAmaral.053d27d9.png";